const fadeOnScreen = () => {

      jQuery(document).ready(function($) {

        let $inc_counter = 0;
        
        /************************************************************** */
        /**** Check if element with class 'fadeOnScreen' is in viewport */
        /************************************************************** */

        /********************* 1° Function for check if lement is in viewport */

        let elementsinviewport = [];

        $.fn.isInViewport = function () {
            var elementTop = $(this).offset().top;
            var elementBottom = elementTop + $(this).outerHeight();

            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        /********************* 2° Call function on load */

        checkonScreen();

        var lastScrollTop = 0;
        $(window).scroll(function (event) {
            var scroll = $(window).scrollTop();
            var header_top = $('.header').outerHeight() + 200;

            if (scroll > lastScrollTop){
              if(lastScrollTop < 0){
                $('.navbar').addClass('scroll_up');
                $('.navbar').removeClass('scroll_down');
              }else{
                $('.navbar').addClass('scroll_down');
                $('.navbar').removeClass('scroll_up');
              }
              
            } else {
              $('.navbar').addClass('scroll_up');
              $('.navbar').removeClass('scroll_down');
            }
            lastScrollTop = scroll;

            if ($(window).scrollTop()  <= 368 ){
              $('body').addClass('onTop');
            }else{
              $('body').removeClass('onTop');
            }

            checkonScreen();
            /* funzione per applicare fadeIn css a elementi all'entrata in viewport */
            if ($(window).scrollTop() + $(window).height() == $(document).height()) {
                elementsinviewport = [];
                
              } else if ($(window).scrollTop() == 0) {
                elementsinviewport = [];
                
              }

        });

        

        function checkonScreen() {
            $(".fadeOnScreen").each(function (index) {
              let $data_delay ="";
              if (typeof $(this).data('delay') !== 'undefined'){
                let delay = $(this).attr("data-delay");
                $data_delay = $(":root").css({"--fade-in-delay-el": delay}); 
              }else{
                $data_delay = $(":root").css({"--fade-in-delay-el": '0s'});
              }
              if ($(this).isInViewport()) {
                $(this).addClass('fadeOnScreen_active');
              } else {
                $(this).removeClass('fadeOnScreen_active');
              }
            });
        }

  })

};

export default fadeOnScreen;
 